<template>
  <div click.stop>
    <div class="modal is-active">
      <div class="modal-background" @click="cancel"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          {{ editFlaw.id ? $t('flaw_modal.update') : $t('flaw_modal.new') }} {{ $t('flaw_modal.flaw') }}
          <button   style="position: absolute; right: 0; top: 50%; transform: translateY(-50%);"class="delete" aria-label="close" @click="cancel"></button>
        </header>
        <section class="modal-card-body no-scroll">
        

<section class="accordion">
  <input type="checkbox" name="collapse" id="handle1" checked="checked">
  <h2 class="handle">
    <label for="handle1">{{ $t('flaw_modal.flaw_name') }}</label>
  </h2>
  <div class="content">

        <div class="columns is-mobile">
            <div class="field column">
              <label class="label">{{ $t('flaw_modal.inventory') }}</label>
              <div class="control">
                <input type="text" v-model="mapItemName" class="input" disabled />
              </div>
            </div>
            <div class="field column">
             	<label class="label">{{ $t('flaw_modal.flaw_name') }}</label>
              <div class="control">
                <input
                  type="text"
                  v-model="flaw.name"
                  class="input"
                  :placeholder="$t('flaw_modal.flaw_placeholder')"
                  disabled
                />
              </div>
            </div>
          </div>
      
          <div class="columns is-mobile">
            <div class="field column">
              <label class="label">{{ $t('flaw_modal.floor') }}</label>
              <div class="control">
                <input
                  type="text"
                  v-model="floorName"
                  class="input"
                  :placeholder="$t('flaw_modal.floor_placeholder')"
                  disabled
                />
              </div>
            </div>
            <div class="field column narrow">
              <label class="label">{{ $t('flaw_modal.position_number') }}</label>
              <div class="control">
                <input
                  type="text"
                  v-model="positionNumber"
                  class="input"
                  :placeholder="$t('flaw_modal.position_number_placeholder')"
                  disabled
                />
              </div>
            </div>
          </div>

          <div class="columns is-mobile">
            <div class="field column">
              <label class="label">{{ $t('flaw_modal.description') }}</label>
              <div class="control">
                <input
                  :disabled="editFlaw.id"
                  type="email"
                  v-model="flaw.description"
                  class="input"
                  :placeholder="$t('flaw_modal.description_placeholder')"
                />
              </div>
            </div>
          </div>
          <div class="columns is-mobile">
            <div class="field column" style="margin-top: 12px">
              <label class="label">{{ $t('flaw_modal.responsible') }}</label>
              <div class="control">
                <input
                  :disabled="editFlaw.id"
                  type="email"
                  v-model="responsible"
                  class="input"
                  :placeholder="$t('flaw_modal.responsible_placeholder')"
                />
              </div>
            </div>
            <div class="field column" style="margin-top: 12px">
              <label class="label">{{ $t('flaw_modal.performer') }}</label>
              <div class="control">
                <input
                  :disabled="editFlaw.id"
                  type="email"
                  v-model="flaw.performer"
                  class="input"
                  :placeholder="$t('flaw_modal.performer_placeholder')"
                />
              </div>
            </div>
          </div>
          <div class="columns is-mobile">
            <div class="field column">
              <label class="label">{{ $t('flaw_modal.measure') }}</label>
              <div class="control">
                <input
                  type="text"
                  v-model="editFlaw.measure"
                  class="input"
                  placeholder="..."
                  :readonly="!isOther"
                />
              </div>
            </div>
            <div class="field column">
              <label class="label">{{ $t('flaw_modal.created') }}</label>
              <div class="control">
                <input type="email" v-model="createdDate" class="input" />
              </div>
            </div>
          </div>
  </div>
</section>
<section class="accordion">
  <input type="checkbox" name="collapse2" id="handle2">
  <h2 class="handle">
    <label for="handle2"> {{ $t('flaw_modal.technical_information') }}</label>
  </h2>
  <div class="content">
     <div class="columns is-mobile">
            <div class="field column">
              <div class="label white">{{ $t('flaw_modal.size') }}</div>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="localItem.size"
                  disabled
                />
              </div>
            </div>
            <div class="field column">
              <div class="label white">{{ $t('flaw_modal.manufacturer') }}</div>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="localItem.manufacture"
                 disabled
                />
              </div>
            </div>
          </div>
		      <div class="columns is-mobile">
            <div class="field column">
              <div class="label white">{{ $t('flaw_modal.other') }}</div>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="localItem.other"
                   disabled
                />
		        	</div>
          </div>

           
          </div>
  </div>
</section>
<section class="accordion" v-if="chunkedFields && chunkedFields.length">
  <input type="checkbox" name="collapse3" id="handle3">
  <h2 class="handle">
    <label for="handle3">{{ $t('flaw_modal.service_information') }}</label>
  </h2>
  <div class="content">
    <div
      v-for="(fieldPair, index) in chunkedFields"
      :key="index"
      class="columns is-mobile"
    >
      <div class="field column" v-for="field in fieldPair" :key="field">
        <label class="label white" v-if="fieldLabels[field]">{{ $t(fieldLabels[field]) }}</label>
        <div class="control">
          <input
            class="input"
            :type="/year/i.test(field) || field === 'FusibleLinkDegrees' ? 'number' : 'text'"
            :value="getExtra(field)"                        
            @input="onExtraInput(field, $event.target.value)"
            :disabled="true"
            placeholder="..."
          />
        </div>
      </div>
    </div>
  </div>
</section>

          <img v-if="imgSrc" class="image-preview" :src="imgSrc" @click="toggleImage" />
        </section>
        <footer class="modal-card-foot">
          <div class="column">
            <button
              class="button is-dark"
              :class="isLoading ? 'is-loading' : ''"
              :disabled="disableSave"
              @click="save"
              v-if="!editFlaw.done"
            >
              <span class="icon is-info"><i class="fas fa-save" /></span
              ><span>{{ $t('flaw_modal.save') }}</span>
            </button>
            <button
              class="button is-dark"
              :class="isLoading ? 'is-loading' : ''"
              :disabled="disableSave"
              @click="fix"
              v-if="!editFlaw.done"
            >
              <span class="icon is-info"><i class="fas fa-check" /></span
              ><span>{{ $t('flaw_modal.fix') }}</span>
            </button>
            <button
              v-if="mapItem && mapFile && showMapButton"
              class="button is-dark"
              :class="isLoading ? 'is-loading' : ''"
              :disabled="disableSave"
              @click="toggleModal"
            >
              <span class="icon is-info"><i class="fas fa-check" /></span
              ><span>{{ $t('flaw_modal.show_on_map') }}</span>
            </button>
          </div>
        </footer>
      </div>
      <div class="image-display" v-if="showImage" @click="toggleImage">
        <img v-if="imgSrc" :src="imgSrc" />
      </div>
    </div>
    <FlawOnMap
      v-if="showMapModal"
      :flaw="mapItem"
      :mapImg="mapFile"
      @cancel="showMapModal = !showMapModal"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import FlawOnMap from "./FlawOnMap.vue";
import fireEquipmentService from "@/mixins/fireEquipmentService.js";

export default {
  components: {
    FlawOnMap,
  },
  props: {
    editFlaw: Object,
    showMapButton: {
      type: Boolean,
      default: false, // visa knappen som standard
    },
  },
  data() {
    return {
      flaw: {
        name: "",
        flaw: "",
        email: "",
        phoneNumber: "",
      },
      isLoading: false,
      responsible: "",
      imgSrc: "",
      showImage: false,
      showMapModal: false,
      mapFile: null,
      localItem: { mapItemExtra: {} },
      fieldLabels: fireEquipmentService.getFieldLabels(),
      fieldMap: fireEquipmentService.getFieldMap(),
        numberFieldsLc: new Set([
        "chargeYear","revisionYear","installationYear","testPressureYear",
        "BatteryInstallationYear","BatteryRevisionYear",
        "ElectrodesInstallationYear","ElectrodesRevisionYear",
        "fusibleLinkDegrees","gasspringRevisionYear",
        'batteryRevisionYear','batteryInstallationYear','electrodesRevisionYear',
        'electrodesInstallationYear','fusibleLinkYear','gasspringRevisionYear',
        'RevisionYear','ChargeYear','InstallationYear','TestPressureYear',
        'FusibleLinkYear','FusibleLinkDegrees','GasspringRevisionYear'
      ].map(s => s.toLowerCase())),
    };
  },
  watch: {
    errorMessage: function () {
      this.isLoading = false;
    },
  },
  computed: {
    ...mapGetters("roleStore", ["role"]),
    ...mapState("fileStore", ["file"]),
    ...mapState("mapStore", ["map"]),
    ...mapGetters("mapItemStore", ["mapItem"]),
    ...mapGetters("roundHistoryInfoStore", ["roundHistoryInfo"]),
    ...mapGetters("user", ["getUser"]),
    disableSave() {
      return false;
    },
    createdDate() {
      return this.moment(this.flaw.created).format("YYYY-MM-DD HH:mm");
    },
    doneDate() {
      return this.flaw.date ? this.moment(this.flaw.date).format("YYYY-MM-DD HH:mm") : "";
    },
    mapItemName() {
      return this.editFlaw.mapItemName || "-";
    },
    floorName() {
      if (this.mapItem.id && this.mapItem.map) {
        return `${this.mapItem.map.floor.buildingName} - ${this.mapItem.map.floor.name}`;
      }

      if (this.roundHistoryInfo.id) {
        return `${this.roundHistoryInfo.buildingName} - ${this.roundHistoryInfo.floorName}`;
      }

      return "";
    },
    positionNumber() {
      return this.mapItem.positionNumber || "-";
    },
    visibleFields() {
      const type = this.localItem.fireProtection?.inventoryType;
      return fireEquipmentService.getVisibleFields(type);
    },
    chunkedFields() {
      const chunkSize = 2;
      const chunks = [];
      for (let i = 0; i < this.visibleFields.length; i += chunkSize) {
        chunks.push(this.visibleFields.slice(i, i + chunkSize));
      }
      return chunks;
    },
	isOther() {
		const key = this.editFlaw?.flawType?.translationKey || '';
		return key.toLowerCase().endsWith('other');
	}
  },
  methods: {
    ...mapActions("roleStore", ["getRole"]),
    ...mapActions("fileStore", ["getFile"]),
    ...mapActions("mapItemStore", ["getMapItem", "setMapItem"]),
    ...mapActions("roundHistoryInfoStore", [
      "getRoundHistoryInfo",
      "setRoundHistoryInfo",
    ]),
    ...mapActions("mapStore", ["getMap"]),
    save() {
      this.$emit("save", this.editFlaw);
    },
    fix() {
      let date = new Date();
      date.setHours(date.getHours() - date.getTimezoneOffset() / 60);
      this.editFlaw.done = date;
      this.editFlaw.doneBy = this.getUser.email;
      this.save();
    },
    cancel() {
      this.$emit("cancel");
    },
    toggleImage() {
      this.showImage = !this.showImage;
    },
    toggleModal() {
      this.showMapModal = !this.showMapModal;
    },
    getExtra(field) {
      const extra = this.localItem?.mapItemExtra || {};
      if (extra[field] !== undefined) return extra[field];
      const lc = String(field).toLowerCase();
      for (const k in extra) {
        if (String(k).toLowerCase() === lc) return extra[k];
      }
      return this.numberFieldsLc.has(lc) ? null : '';
    },

    setExtra(field, val) {
      const extra = this.localItem.mapItemExtra || {};
      const lc = String(field).toLowerCase();
      for (const k in extra) {
        if (k !== field && String(k).toLowerCase() === lc) {
          this.$delete(extra, k);
        }
      }
      this.$set(extra, field, val);
    },

    onExtraInput(field, raw) {
      const isNum = this.numberFieldsLc.has(String(field).toLowerCase());
      const coerced = isNum ? (raw === '' || raw == null ? null : Number(raw)) : raw;
      this.setExtra(field, coerced);
    },

    normalizeExtraKeys() {
      const extra = this.localItem?.mapItemExtra || {};
      const normalized = {};
      const fields = this.visibleFields || [];
      fields.forEach(f => {
        const v = this.getExtra(f);
        if (v !== undefined) normalized[f] = v;
      });
      // copy over any non-visible leftovers (don’t lose data)
      for (const k in extra) {
        const already = Object.keys(normalized).some(f => f.toLowerCase() === k.toLowerCase());
        if (!already) normalized[k] = extra[k];
      }
      this.$set(this.localItem, 'mapItemExtra', normalized);
    },

    syncServiceFields() {
      const type = this.localItem.fireProtection?.inventoryType;
      const fields = fireEquipmentService.getVisibleFields(type) || [];
      this.normalizeExtraKeys();
      const next = { ...this.localItem.mapItemExtra };
      fields.forEach((f) => {
        const val = this.getExtra(f);
        const isEmpty = val === undefined || val === null || val === '';
        const isNum = this.numberFieldsLc.has(String(f).toLowerCase());
        if (isEmpty) next[f] = isNum ? null : '';
      });
      this.$set(this.localItem, 'mapItemExtra', next);
    },
  },
  async created() {
    if (this.editFlaw.id) {
      Object.assign(this.flaw, this.editFlaw);
    }
    if (this.editFlaw.responsible != null) {
      await this.getRole(this.editFlaw.responsible);
      this.responsible = this.role.name || this.editFlaw.responsible;
    } else {
      this.responsible = "";
    }

    if (this.flaw.mapItemId) {
      await this.getMapItem(this.flaw.mapItemId);
      this.localItem = {
        ...this.mapItem,
        mapItemExtra: this.mapItem.mapItemExtra || {},
      };

      this.visibleFieldsArray = fireEquipmentService.getVisibleFields(
        this.localItem.fireProtection?.inventoryType
      );

      await this.getMap(this.mapItem.map.id);

      if (this.map.file && this.map.file.id) {
        this.mapFile = await this.getFile(this.map.file.id);
      }
    } else {
      this.setMapItem({});
    }

    if (this.flaw.roundHistoryInfoId) {
  await this.getRoundHistoryInfo(this.flaw.roundHistoryInfoId);
  await this.getMap(this.roundHistoryInfo.mapId);

  if (this.map.file && this.map.file.id) {
    this.mapFile = await this.getFile(this.map.file.id);
  }

  const items = this.roundHistoryInfo?.roundHistoryItems || [];
  const mapItemId = this.flaw.mapItemId;
  let relatedItem = items.find(
    (item) => item.mapItemId === mapItemId || item.mapItem?.id === mapItemId
  );

  if (!relatedItem && items.length > 0) {
    console.warn("⚠️ Ingen exakt match, använder första posten i RoundHistoryItems");
    relatedItem = items[0];
  }

  if (relatedItem) {
    this.setMapItem({
      ...relatedItem.mapItem,
      mapItemExtra: relatedItem.roundHistoryMapItemExtra || {},
      fireProtection: { inventoryType: relatedItem.inventoryType || "misc" },
      name: relatedItem.name,
      placementDescription: relatedItem.placementDescription,
      positionX: relatedItem.positionX,
      positionY: relatedItem.positionY,
      positionNumber: relatedItem.positionNumber,
      map: {
        floor: {
          name: this.roundHistoryInfo.floorName,
          buildingName: this.roundHistoryInfo.buildingName,
        },
        name: this.map.name,
      },
    });

    this.localItem = {
      ...this.mapItem,
      inventoryType: relatedItem.inventoryType,
      fireProtection: { inventoryType: relatedItem.inventoryType },
      mapItemExtra: relatedItem.roundHistoryMapItemExtra || {},
    };
    this.syncServiceFields();     

  } else {
    console.warn("⚠️ Hittade ingen matchande RoundHistoryItem för mapItemId:", mapItemId);
  }
} else {
  this.setRoundHistoryInfo({});
}

    if (this.editFlaw.fileId) {
      this.getFile(this.editFlaw.fileId).then(() => {
        this.imgSrc = this.file;
      });
    }
  },
};
</script>

<style lang="scss">
.multiselect.panel-select.flaw .multiselect__tags {
  white-space: normal;
}
</style>

<style lang="scss" scoped>
.image-preview {
  margin-top: 1rem;
  max-width: 5rem;
  background: white;
  cursor: pointer;
}

.image-display {
  position: absolute;
  z-index: 10;
  background: rgba(0, 0, 0, 0.486);
  height: 80%;
  width: 80%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    display: block;
    height: 80%;
  }
}
.field.column.narrow {
  max-width: 80px;
}
input.input {
  height: 36px;
}
.modal-card-body.no-scroll {
  padding: 0 10px;
}

</style>
